import { type IDemo, RecordingTypes } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useLinksPermissions = () => {
  const { shareDesktopAppBasedClone } = useFlags();
  const isDemoCreatedByDesktop = (demo: IDemo) => {
    return demo?.recordingType === RecordingTypes.native;
  };

  const getIsDemoShareable = (demo: IDemo) =>
    !isDemoCreatedByDesktop(demo) ||
    (shareDesktopAppBasedClone && isDemoCreatedByDesktop(demo));

  return { getIsDemoShareable };
};
